import { useState } from 'react'
import { utils, writeFileXLSX } from '@e965/xlsx'

export const useExportCsv = ({
    data,
    fileName,
}: {
    data: {
        csvData: Record<string, string>[]
        wsName: string
        colWidth: number
    }[]
    fileName: string
}) => {
    const [error, setError] = useState<unknown>(null)

    const exportFile = () => {
        try {
            const wb = utils.book_new()
            data.forEach((value) => {
                const wsData = utils.json_to_sheet(value.csvData)
                const numOfCols =
                    value.csvData[0] && Object.keys(value.csvData[0]).length

                wsData['!cols'] = new Array(numOfCols).fill({
                    wpx: value.colWidth,
                })

                utils.book_append_sheet(wb, wsData, value.wsName)
            })

            writeFileXLSX(wb, `${fileName}.xlsx`)
        } catch (err) {
            setError(err)
        }
    }

    return {
        exportFile,
        error,
    }
}
